import Collapse from "components/Collapse";
import EmptyState from "components/EmptyState";
import Loader from "components/Loader";
import { CatGatedProjectLink } from "pages/project/common/taskBase/list/CatGatedProjectLink";
import { useTranslate5ProjectLinkList } from "query/task.query";
import { useTranslation } from "react-i18next";

interface Props {
  taskId: string;
  /** Lets Task gate opening the CAT project behind the mandatory instructions confirmation. */
  onBeforeOpen?: (open: () => void) => void;
  /** Non-interactive links while mandatory-instruction ack cannot decide (loading/error). */
  disabled?: boolean;
}

export const Translate5ProjectLinksTable = ({ taskId, onBeforeOpen, disabled }: Props) => {
  const { t } = useTranslation();
  const { links, hasLinks, isFetching, error } = useTranslate5ProjectLinkList(taskId);

  if (isFetching) {
    return <Loader isShown={true} />;
  }

  if (!hasLinks) {
    return (
      <EmptyState
        title={t("task.detail.jobLinks.translate5.title")}
        subtitle={error ? t("error:common.server") : t("task.detail.catProjectLinks.title-no-project-links-detail")}
      />
    );
  }

  return (
    <Collapse
      defaultOpen={true}
      header={
        <h5 className="my-2 space-x-2 font-medium">
          <span>{t("task.detail.jobLinks.translate5.title")}</span>
          <span>({links.length})</span>
        </h5>
      }
    >
      <ul className="ml-6 max-h-[200px] list-none overflow-y-auto">
        {links.map((link) => (
          <li key={link.projectId} className="my-2">
            <CatGatedProjectLink
              href={link.projectLink}
              dataTest="link-open-translate5-link"
              dataDdActionName="btn-open-translate5-link"
              onBeforeOpen={onBeforeOpen}
              disabled={disabled}
            >
              <span>{link.projectName}</span>
            </CatGatedProjectLink>
          </li>
        ))}
      </ul>
    </Collapse>
  );
};
